import styled, { css } from 'styled-components'

export const WidgetContainer = styled.div`
  ${({ theme = {} }) => css`
    width: 12rem;
    border-radius: 1px;
  `}
  padding: 1.875rem;

  height: auto;
  border: 1px solid #aaaaaa;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`
